import request from '@/utils/request'

function unwrapPage(res) {
  if (res && res.code && res.code !== 2000) {
    return Promise.reject(new Error(res.message || '请求失败'))
  }
  const page = (res && res.items) || res || {}
  return {
    records: page.Data || page.data || page.records || [],
    total: page.totalCount != null ? page.totalCount : (page.total || 0)
  }
}

export function recordLogHistory(data) {
  return request({
    url: '/pc/profile/logHistory/record',
    method: 'post',
    data
  })
}

export function fetchLogHistoryPage(params) {
  return request({
    url: '/pc/profile/logHistory/page',
    method: 'get',
    params
  }).then(unwrapPage)
}

export const LOG_HISTORY_TYPE = {
  ENTITY: 1,
  RESOURCE: 2,
  EXHIBITION: 3
}

export const LOG_HISTORY_TABS = [
  { label: '实体', value: LOG_HISTORY_TYPE.ENTITY },
  { label: '资源', value: LOG_HISTORY_TYPE.RESOURCE },
  { label: '主题', value: LOG_HISTORY_TYPE.EXHIBITION }
]

const ENTITY_ROUTE_TYPES = ['renwu', 'jigou', 'didian', 'shijian']

function formatCreateTime(value) {
  if (!value) return '-'
  const text = String(value).replace('T', ' ').trim()
  if (text.length >= 16) {
    return text.slice(0, 16)
  }
  return text
}

export function mapLogHistoryItem(item) {
  const type = item.type
  const dataId = item.dataId
  let path = '/'

  if (type === LOG_HISTORY_TYPE.ENTITY) {
    const entityType = normalizeEntityRouteType(item.entityType)
    path = `/knowledge/${entityType}/${dataId}`
  } else if (type === LOG_HISTORY_TYPE.RESOURCE) {
    path = `/resources/${dataId}`
  } else if (type === LOG_HISTORY_TYPE.EXHIBITION) {
    path = `/exhibition/${dataId}`
  }

  return {
    id: item.id,
    type,
    dataId,
    title: item.title || '未命名',
    coverImage: item.coverImage || '',
    createTime: formatCreateTime(item.createTime),
    path
  }
}

function normalizeEntityRouteType(code) {
  const value = String(code || '').trim().toLowerCase()
  if (ENTITY_ROUTE_TYPES.includes(value)) {
    return value
  }
  return 'renwu'
}
